module.exports = __webpack_public_path__ + "static/img/home_06.d07e1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_06.jpg
// module id = XrZ7
// module chunks = 1